import {
    Row,
    Col,
    Typography
} from "antd"

import { useEffect, useState } from "react";

import { SearchInput, SearchResults } from "@/components/search"




const SearchBrands = ({ searchModule, searchPlaceholder }) => {
    useEffect(() => {
        async function loadData() {
            await searchModule.actions.fetch_results()
        }
        loadData()
    }, [])

    return <Row gutter={0} style={{marginTop: "-8px"}}>
        <Col span={24}>
            {/* <SearchInput searchModule={searchModule} searchPlaceholder={searchPlaceholder} /> */}
            <SearchResults searchModule={searchModule} />
        </Col>
    </Row>

}
export default SearchBrands;